import { render, staticRenderFns } from "./OperatingExpense.vue?vue&type=template&id=1d05731c"
import script from "./OperatingExpense.vue?vue&type=script&lang=js"
export * from "./OperatingExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d05731c')) {
      api.createRecord('1d05731c', component.options)
    } else {
      api.reload('1d05731c', component.options)
    }
    module.hot.accept("./OperatingExpense.vue?vue&type=template&id=1d05731c", function () {
      api.rerender('1d05731c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/OperatingExpense.vue"
export default component.exports